import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Note ", -1)

import { ref, nextTick } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import { Field } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesRebateSchemaNote',
  setup(__props, { expose: __expose }) {

const salesRebateSchemaNoteShowRef = ref<any>(null);
const schemaInfo = ref({} as any);

const show = async (_item: any) => {
  salesRebateSchemaNoteShowRef.value?.show();
  schemaInfo.value = _item;
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "salesRebateSchemaNoteShowRef",
    ref: salesRebateSchemaNoteShowRef,
    title: 'Schema Note',
    "is-loading": false,
    width: 500,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(Field), {
              modelValue: schemaInfo.value.note,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schemaInfo.value.note) = $event)),
              class: "form-control form-control-lg form-control-solid",
              name: "symbolRule",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: schemaInfo.value.note,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schemaInfo.value.note) = $event)),
                  size: "large",
                  rows: 5,
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})